import React from "react";

type StatsReferralCardProps = {
  title: string;
  value: number | string;
  icon: string | React.ReactNode;
  className? : string;
  iconSize? :  number;
};


const StatReferralCard: React.FC<StatsReferralCardProps> = ({ title, value, icon ,iconSize =32 ,  className }) => {
  const renderIcon = () => {
    if (typeof icon === "string") {
      return (
        <img
          src={icon}
          alt={title}
          style={{
            width: "70%",
            height: "auto",
            objectFit: "contain"            
          }}
        />
      );
    }
    return icon;
  };

  return (    
    <div
      className="hover:shadow-md"
      style={{
        background: "#fff",
        borderRadius: "8px",
        padding: "10px",
        textAlign: "center",
        boxShadow: "0 1px 4px rgba(0,0,0,0.05)",
      }}
    >
      <div
        className={className}
        style={{
          fontSize: "1.5rem", 
          fontWeight: 600,
          color: "#5c628a",
          marginBottom: "4px",
        }}
      >
        {value}
      </div>

      <div
        style={{
          width: iconSize,
          height: iconSize,
          margin: "0 auto 4px", 
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {renderIcon()}
      </div>

      <div
        style={{
          fontSize: "1.2rem", 
          color: "#6b7280",
        }}
      >
        {title}
      </div>
    </div>
  );
};

export default StatReferralCard;